import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../utils/constant';

const initialState = {
  brands: [],
  loading: false,
  error: null,
};

// Fetch all brands for a company
export const fetchBrands = createAsyncThunk('brands/fetchBrands', async (company_id) => {
  const response = await axios.get(`${API_URL}/brands/${company_id}`);
  return response.data;
});

// Create a new brand
export const createBrand = createAsyncThunk('brands/createBrand', async (brandData) => {
  const response = await axios.post(`${API_URL}/brands`, brandData);
  return response.data;
});

// Update a brand
export const updateBrand = createAsyncThunk('brands/updateBrand', async ({ id, brandData }) => {
  const response = await axios.put(`${API_URL}/brands/${id}`, brandData);
  return response.data;
});

// Delete a brand
export const deleteBrand = createAsyncThunk('brands/deleteBrand', async (id) => {
  await axios.delete(`${API_URL}/brands/${id}`);
  return id;
});

const brandSlice = createSlice({
  name: 'brands',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchBrands.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBrands.fulfilled, (state, action) => {
        state.loading = false;
        state.brands = Array.isArray(action.payload) ? action.payload : [];
        state.error = null;
      })
      .addCase(fetchBrands.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Create
      .addCase(createBrand.pending, (state) => {
        state.loading = true;
      })
      .addCase(createBrand.fulfilled, (state, action) => {
        state.loading = false;
        state.brands.push(action.payload);
        state.error = null;
      })
      .addCase(createBrand.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Update
      .addCase(updateBrand.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateBrand.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.brands.findIndex(brand => brand.id === action.payload.id);
        if (index !== -1) {
          state.brands[index] = action.payload;
        }
        state.error = null;
      })
      .addCase(updateBrand.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Delete
      .addCase(deleteBrand.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteBrand.fulfilled, (state, action) => {
        state.loading = false;
        state.brands = state.brands.filter(brand => brand.id !== action.payload);
        state.error = null;
      })
      .addCase(deleteBrand.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default brandSlice.reducer; 